import {
  G_USER_MODULE,
  G_TEMPLATES_MODULE,
  G_TASKS_MODULE,
} from "./module.type";

export const CACHED            = "cached";
export const IS_WATCHING       = "is_watching";
export const STORED            = "stored";
export const DOCUMENT_LISTENER = "document_listener";
export const REF               = "ref";
export const ACCESS            = "access";
export const LAST_FETCHED      = "last_fetched";
export const MODULE_NAME       = "moduleName";

// tasks.store.js
export const ALL_TASKS                    = "all_tasks";
export const SORTED                       = "sorted";
export const FILTERED                     = "filtered";
export const GROUP_ACTION_LISTENERS       = "group_action_listeners";
export const IS_LISTENING_TO_GROUP_ACTION = "is_listening_to_group_action";
export const IS_LISTENING_TO_NOTIFICATIONS = "is_listening_to_notifications";

// user.store.js
export const ALL_GROUPS         = "all_groups";
export const DEFAULT_GROUP      = "default_group";
export const GROUP_STORED       = "group_stored";
export const GROUP              = "group";
export const ID                 = "id";
export const IN_GROUP           = "in_group";
export const USER_ID            = "user_id";
export const AVATAR_STORAGE_REF = "avatar_storage_ref";
export const LOGGED_ID          = "loggedIn";
export const FCM_TOKEN          = "fcm_token";
export const SELECTED_GROUP     = "selected_group";
export const SELECTED_CONTEXT   = "selected_context";

// context.store.js
export const CONTEXT_DOC = "context_doc";

// templates.store.js
export const TEMPLATE = "template";

// Globals (accessing from root of the store)
export const G_USER_GROUPS      = `${G_USER_MODULE}/${ALL_GROUPS}`;
export const G_DEFAULT_GROUP    = `${G_USER_MODULE}/${DEFAULT_GROUP}`;
export const G_USER_ID          = `${G_USER_MODULE}/${USER_ID}`;
export const G_SELECTED_GROUP   = `${G_USER_MODULE}/${SELECTED_GROUP}`;
export const G_SELECTED_CONTEXT = `${G_USER_MODULE}/${SELECTED_CONTEXT}`;
export const G_USER_FCM_TOKEN   = `${G_USER_MODULE}/${FCM_TOKEN}`;
export const G_USER_REF         = `${G_USER_MODULE}/${REF}`;

export const G_ALL_USER_TASKS   = `${G_TASKS_MODULE}/${ALL_TASKS}`;

export const G_LOADING          = "loading";


// Option types (enum like)
export const NEVER_FETCHED = "never";